import React, { useState } from "react";
import BaseApiCall from "../../api/BaseApiCall";

const RunQuery = () => {
  const [query, setQuery] = useState("");
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setResponse(null);

    try {
      const res = await BaseApiCall.post("/au/run-query", e);
      setResponse(res.data);
    } catch (err) {
      setError(err.response?.data?.message || "An error occurred while executing the query.");
    }
  };

  return (
    <div>
      <div className="p-8 max-w-xl mx-auto">
        <h1 className="text-2xl font-bold mb-4 text-gray-800">MySQL Query Executor</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="query" className="block text-gray-700 font-semibold mb-2">
              Enter your MySQL Query:
            </label>
            <textarea
              id="query"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              rows="6"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
              placeholder="Write your SQL query here..."
              required
            ></textarea>
          </div>
          <button
            type="submit"
            className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition-all duration-300"
          >
            Execute Query
          </button>
        </form>
        {response && (
          <div className="mt-6 p-4 bg-green-100 text-green-800 rounded-lg">
            <h2 className="font-semibold">Response:</h2>
            <pre className="whitespace-pre-wrap">{JSON.stringify(response, null, 2)}</pre>
          </div>
        )}
        {error && (
          <div className="mt-6 p-4 bg-red-100 text-red-800 rounded-lg">
            <h2 className="font-semibold">Error:</h2>
            <p>{error}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default RunQuery;